import React from 'react';
import './PartnerStoriesLogos.css';
import Intro from './Intro';
import OptimizedImage from './OptimizedImage';

import VisaLogo from 'url:../../assets-optimized/redesign/logos/visa.png';
import VisaLogoavif from 'url:../../assets-optimized/redesign/logos/visa.avif';
import VisaLogowebp from 'url:../../assets-optimized/redesign/logos/visa.webp';
import PepsiCoLogo from 'url:../../assets-optimized/redesign/logos/pepsico.png';
import PepsiCoLogoavif from 'url:../../assets-optimized/redesign/logos/pepsico.avif';
import PepsiCoLogowebp from 'url:../../assets-optimized/redesign/logos/pepsico.webp';
import UberLogo from 'url:../../assets-optimized/redesign/logos/uber.png';
import UberLogoavif from 'url:../../assets-optimized/redesign/logos/uber.avif';
import UberLogowebp from 'url:../../assets-optimized/redesign/logos/uber.webp';
import StarbucksLogo from 'url:../../assets-optimized/redesign/logos/starbucks.png';
import StarbucksLogoavif from 'url:../../assets-optimized/redesign/logos/starbucks.avif';
import StarbucksLogowebp from 'url:../../assets-optimized/redesign/logos/starbucks.webp';
import UALogo from 'url:../../assets-optimized/redesign/logos/united.png';
import UALogoavif from 'url:../../assets-optimized/redesign/logos/united.avif';
import UALogowebp from 'url:../../assets-optimized/redesign/logos/united.webp';
import AudibleLogo from 'url:../../assets-optimized/redesign/logos/audible.png';
import AudibleLogoavif from 'url:../../assets-optimized/redesign/logos/audible.avif';
import AudibleLogowebp from 'url:../../assets-optimized/redesign/logos/audible.webp';
import AMEXLogo from 'url:../../assets-optimized/redesign/logos/amex.png';
import AMEXLogoavif from 'url:../../assets-optimized/redesign/logos/amex.avif';
import AMEXLogowebp from 'url:../../assets-optimized/redesign/logos/amex.webp';
import AdobeLogo from 'url:../../assets-optimized/redesign/logos/adobe.png';
import AdobeLogoavif from 'url:../../assets-optimized/redesign/logos/adobe.avif';
import AdobeLogowebp from 'url:../../assets-optimized/redesign/logos/adobe.webp';
const PartnerStoriesLogos = () => {
  return (
    <>
      <div className='cs-logos-section'>
        <div className='cs-logos-container'>
          <OptimizedImage className='cs-logo-img' avif={VisaLogoavif} webp={VisaLogowebp} fallback={VisaLogo} alt='Visa' />
          <OptimizedImage className='cs-logo-img' avif={PepsiCoLogoavif} webp={PepsiCoLogowebp} fallback={PepsiCoLogo} alt='PepsiCo' />
          <OptimizedImage className='cs-logo-img' avif={UberLogoavif} webp={UberLogowebp} fallback={UberLogo} alt='Uber' />
          <OptimizedImage className='cs-logo-img' avif={StarbucksLogoavif} webp={StarbucksLogowebp} fallback={StarbucksLogo} alt='Starbucks' />
          <OptimizedImage className='cs-logo-img' avif={UALogoavif} webp={UALogowebp} fallback={UALogo} alt='United Airlines' />
          <OptimizedImage className='cs-logo-img' avif={AudibleLogoavif} webp={AudibleLogowebp} fallback={AudibleLogo} alt='Audible' />
          <OptimizedImage className='cs-logo-img' avif={AMEXLogoavif} webp={AMEXLogowebp} fallback={AMEXLogo} alt='American Express' />
          <OptimizedImage className='cs-logo-img' avif={AdobeLogoavif} webp={AdobeLogowebp} fallback={AdobeLogo} alt='Adobe' />
        </div>
      </div>
    </>
  );
};

export default PartnerStoriesLogos;
